import { useState } from 'react';
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from './ui/sheet';
import { Menu, Plus, Key, Search, LogOut, User } from 'lucide-react';

export default function MobileMenu({ portfolioRef, searchRef, userRole, userEmail, onLogout }) {
  const [open, setOpen] = useState(false);

  const trigger = (fn) => () => {
    setOpen(false);
    // Small delay so the sheet close animation finishes before another modal opens
    setTimeout(() => {
      try { fn && fn(); } catch (e) { /* noop */ }
    }, 220);
  };

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <button
          className="hamburger-toggle"
          aria-label="Open menu"
          data-testid="mobile-menu-button"
        >
          <Menu size={22} />
        </button>
      </SheetTrigger>
      <SheetContent side="right" className="w-[280px]" data-testid="mobile-menu-drawer">
        <SheetHeader>
          <SheetTitle>Menu</SheetTitle>
        </SheetHeader>

        <div className="mobile-menu-user" data-testid="mobile-menu-user">
          <User size={16} />
          <span>{userEmail}</span>
        </div>

        <div className="mobile-menu-items">
          <button
            className="mobile-menu-item"
            onClick={trigger(() => searchRef?.current?.openSearch?.())}
            data-testid="mobile-search-units"
          >
            <Search size={18} />
            Search Units
          </button>

          {userRole === 'owner' && (
            <button
              className="mobile-menu-item"
              onClick={trigger(() => portfolioRef?.current?.openCreate?.())}
              data-testid="mobile-new-portfolio"
            >
              <Plus size={18} />
              New Portfolio
            </button>
          )}

          <button
            className="mobile-menu-item"
            onClick={trigger(() => portfolioRef?.current?.openJoin?.())}
            data-testid="mobile-join-portfolio"
          >
            <Key size={18} />
            Join Portfolio
          </button>

          <button
            className="mobile-menu-item mobile-menu-item--danger"
            onClick={trigger(onLogout)}
            data-testid="mobile-logout"
          >
            <LogOut size={18} />
            Logout
          </button>
        </div>
      </SheetContent>
    </Sheet>
  );
}
